import React from "react";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import styled, { withTheme } from "styled-components";

const StyledOutlineBtn = styled(Button)`
  color: ${(props) =>
    props?.type === "primary"
      ? props?.theme?.darkPurple
      : props?.theme?.yellowGreen};
  background-color: ${(props) => props?.theme?.glassy};
  border-color: ${(props) =>
    props?.type === "primary"
      ? props?.theme?.darkPurple
      : props?.theme?.yellowGreen};
  &:hover {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) =>
      props?.type === "primary"
        ? props?.theme?.darkPurple
        : props?.theme?.yellowGreen};
    border-color: ${(props) =>
      props?.type === "primary"
        ? props?.theme?.darkPurple
        : props?.theme?.yellowGreen};
  }
  &:focus {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) =>
      props?.type === "primary"
        ? props?.theme?.darkPurple
        : props?.theme?.yellowGreen};
    border-color: ${(props) =>
      props?.type === "primary"
        ? props?.theme?.darkPurple
        : props?.theme?.yellowGreen};
    box-shadow: ${(props) =>
      props?.type === "primary"
        ? props?.theme?.primaryShadow
        : props?.theme?.accentShadow};
  }
  &:disabled,
  &:not(:disabled):not(.disabled):active,
  :not(:disabled):not(.disabled).active,
  .show > .dropdown-toggle {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) =>
      props?.type === "primary"
        ? props?.theme?.lavenderRose
        : props?.theme?.pixieGreen};
    border-color: ${(props) =>
      props?.type === "primary"
        ? props?.theme?.lavenderRose
        : props?.theme?.pixieGreen};
  }
  &:not(:disabled):not(.disabled):active:focus,
  .show > .dropdown-toggle:focus {
    box-shadow: ${(props) =>
      props?.type === "primary"
        ? props?.theme?.lavenderShadow
        : props?.theme?.accentShadow};
  }
  &.show-icon {
    position: relative;
    padding: 0.5rem 1rem 0.5rem 2rem;
    min-width: 130px;
    &:last-child {
      margin-left: 4px;
    }
    i {
      position: absolute;
      left: 15px;
      top: 12px;
    }
  }
`;

const OutlineButton = (props) => {
  const { text, size, type = "primary", icon = null } = props;

  return (
    <StyledOutlineBtn
      {...props}
      size={size}
      type={type}
      className={`${icon && "show-icon btn-sm"}`}
    >
      {icon && <i className={icon} />}
      {text || props.children}
    </StyledOutlineBtn>
  );
};

OutlineButton.propTypes = {
  size: PropTypes.oneOf(["lg", "", "sm"]),
  text: PropTypes.string,
  type: PropTypes.oneOf(["primary", "accent"]),
};

export default withTheme(OutlineButton);
